import React from "react";
import { Link } from "react-router-dom";

const Header: React.FC = () => {
  return (
    <header className="bg-blue-600 text-white p-4">
           {" "}
      <nav className="container mx-auto flex justify-between items-center">
               {" "}
        <div className="text-lg font-bold">
                    <Link to="/">Tours</Link>
                 {" "}
        </div>
               {" "}
        <ul className="flex space-x-4">
                   {" "}
          <li>
                       {" "}
            <Link to="/" className="hover:underline">
              Inicio
            </Link>
                     {" "}
          </li>
                   {" "}
          <li>
                       {" "}
            <Link to="/contacto" className="hover:underline">
              Contacto
            </Link>
                     {" "}
          </li>
                   {" "}
          <li>
                       {" "}
            <Link to="/productos" className="hover:underline">
              Productos
            </Link>
                     {" "}
          </li>
                 {" "}
        </ul>
             {" "}
      </nav>
         {" "}
    </header>
  );
};

export default Header;
